import styled from 'styled-components';
import {GeneralTitleCasino777Box} from '../../../../../basic-components/general-title/general-title.casino777.box';


export const SectionTitleCasino777Box = styled(GeneralTitleCasino777Box)`
    font-family: ${props => props.theme.font.family.bold};
    color: ${props => props.theme.colors.textLight};
    text-transform: uppercase;
    font-size: 1.6rem;
    background-image: url("${props => props.theme.images.spriteSheet.toString()}");
    background-position: -155px -861px;
    height: 40px;
    &:before{
        content: none;
    }
`;